var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 36C28.165 36 36 28.165 36 18.5C36 8.83502 28.165 1 18.5 1C8.83502 1 1 8.83502 1 18.5C1 28.165 8.83502 36 18.5 36Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4837 14.9671C15.303 14.9671 15.9672 14.3029 15.9672 13.4835C15.9672 12.6642 15.303 12 14.4837 12C13.6643 12 13.0001 12.6642 13.0001 13.4835C13.0001 14.3029 13.6643 14.9671 14.4837 14.9671Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7198 15.9581H13.2473C13.1108 15.9581 13 16.0689 13 16.2054V23.6231C13 23.7596 13.1108 23.8704 13.2473 23.8704H15.7198C15.8563 23.8704 15.9671 23.7596 15.9671 23.6231V16.2054C15.9671 16.0689 15.8563 15.9581 15.7198 15.9581Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0882 15.5468C22.0314 15.1848 20.7095 15.5028 19.9168 16.0729C19.8896 15.9666 19.7927 15.8875 19.6775 15.8875H17.2049C17.0684 15.8875 16.9576 15.9983 16.9576 16.1347V23.5525C16.9576 23.689 17.0684 23.7998 17.2049 23.7998H19.6775C19.814 23.7998 19.9247 23.689 19.9247 23.5525V18.2216C20.3243 17.8774 20.8391 17.7676 21.2604 17.9467C21.6689 18.1192 21.9028 18.5406 21.9028 19.1018V23.5525C21.9028 23.689 22.0136 23.7998 22.1501 23.7998H24.6227C24.7591 23.7998 24.8699 23.689 24.8699 23.5525V18.6039C24.8417 16.5719 23.8858 15.8197 23.0882 15.5468Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.8553fca4884ab5c9ad5ccd1d10050721.svg";
export { ForwardRef as ReactComponent };